import React from 'react'
import { Button } from '.'
import type { ButtonProps } from './type'
import type { Element } from 'react'
import { colors } from 'app-v2/design-systems/theme'

type Props = {
    icon?: Element<any>
}

export const IconButtonMobile = (props: ButtonProps & Props) => {
    const {
        icon,
        otherStyle,
        labelColor = colors.mayoEggWhite,
        buttonColor = colors.fieryRed
    } = props
    return (
        <Button
            labelColor={labelColor}
            buttonColor={buttonColor}
            small
            otherStyle={{ padding: 5, ...otherStyle }}
            {...props}>
            {icon}
        </Button>
    )
}
